<template>
  <div>
    <v-form ref="form" v-model="valid">
      <v-card dark style="border-radius:10px;">
        <v-layout wrap row justify-space-between class="pa-3">
          <v-flex xs12 sm2 class="px-1 search__input">
            <v-layout column>
              <v-flex>Store :</v-flex>
              <v-autocomplete
                :loading="is_loading_store"
                :items="store_list"
                v-model="
                  $store.state[action_method].config_path.search_store_id
                "
                item-text="store_name_th"
                item-value="store_id"
                cache-items
                flat
                hide-no-data
                hide-details
                :rules="
                  $store.state[action_method].config_path.search_store_id == 0
                    ? []
                    : [rules.required]
                "
              ></v-autocomplete>
              <v-flex></v-flex>
            </v-layout>
          </v-flex>
          <v-flex
            xs12
            sm2
            class="px-1 search__input"
            v-if="
              'district_id' in $store.state[action_method].config_path &&
                ('province_id' in $store.state[action_method].config_path ==
                  false ||
                  $store.state[action_method].config_path.province_id != 0) &&
                $store.state[action_method].config_path.search_store_id == 0
            "
          >
            <v-layout column>
              <v-flex>District :</v-flex>
              <v-autocomplete
                :loading="is_loading_store"
                :items="districtList"
                v-model="$store.state[action_method].config_path.district_id[0]"
                item-text="district_name_th"
                item-value="district_id"
                cache-items
                flat
                hide-no-data
                hide-details
              ></v-autocomplete>
              <v-flex></v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 sm2 class="px-1 search__input">
            <v-layout column>
              <v-flex>Status :</v-flex>
              <v-flex>
                <v-select
                  v-model="$store.state[action_method].config_path.order_status"
                  item-text="name"
                  item-value="value"
                  :items="order_status"
                  hide-details
                  :rules="
                    $store.state[action_method].config_path.order_status == 0
                      ? []
                      : [rules.required]
                  "
                ></v-select>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 sm2 class="px-1 search__input">
            <v-layout column>
              <v-flex>Start :</v-flex>
              <v-flex>
                <v-menu
                  :close-on-content-click="false"
                  v-model="menu1"
                  :nudge-right="-30"
                  lazy
                  transition="scale-transition"
                  offset-y
                  style="width:100%"
                >
                  <v-text-field
                    slot="activator"
                    v-model="
                      $store.state[action_method].config_path.datetime_start
                    "
                    prepend-icon="event"
                    hide-details
                    readonly
                    :rules="[rules.required]"
                  ></v-text-field>
                  <v-date-picker
                    color="#333"
                    no-title
                    v-model="
                      $store.state[action_method].config_path.datetime_start
                    "
                    @input="menu1 = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 sm2 class="px-1 search__input">
            <v-layout column>
              <v-flex>End :</v-flex>
              <v-flex>
                <v-menu
                  :close-on-content-click="false"
                  v-model="menu2"
                  :nudge-right="-30"
                  lazy
                  transition="scale-transition"
                  offset-y
                  style="width:100%"
                >
                  <v-text-field
                    slot="activator"
                    v-model="
                      $store.state[action_method].config_path.datetime_end
                    "
                    prepend-icon="event"
                    hide-details
                    readonly
                    :rules="[rules.required]"
                  ></v-text-field>
                  <v-date-picker
                    color="#333"
                    no-title
                    v-model="
                      $store.state[action_method].config_path.datetime_end
                    "
                    @input="menu2 = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 sm2 style="display:flex;justify-content:center">
            <div class="pt-2 text-xs-center search-btn" @click="seach()">
              <v-progress-circular
                indeterminate
                color="black"
                v-if="seaching"
              ></v-progress-circular>
              <v-icon large color="black" v-else>search</v-icon>
            </div>
          </v-flex>
        </v-layout>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  props: {
    action_method: {
      default() {
        return "fetchSaleStoreReport";
      },
    },
  },
  data() {
    return {
      seaching: false,
      rules: {
        required: (value) => !!value || "required",
      },
      valid: true,
      store_list: [],
      order_status: [
        { name: "Complete", value: 6 },
        { name: "Cancel", value: 7 },
      ],
      menu1: false,
      menu2: false,
      date: new Date().toISOString().substr(0, 10),
      is_loading_store: false,
      districtList: [
        {
          district_id: 0,
          district_name_th: "ทุกอำเภอ",
          district_name_en: "All district",
        },
      ],
      isLoadingDistrict: false,
    };
  },
  computed: {
    ...mapState({
      provinceData: (state) => state.fetchProvinceBack.provinceData,
      provinceNameEn: (state) => state.backOffice.province,
    }),
  },
  methods: {
    ...mapActions({
      fetchDistrictCore: "fetchProvinceBack/getDistrictCore",
    }),
    async fetchDistrictList() {
      this.isLoadingDistrict = true;
      let province = this.provinceData.find(
        (val) =>
          val.province_name_en.replace(/ /g, "").toLowerCase() ===
          this.provinceNameEn.toLowerCase()
      );
      let districtByProvince = await this.fetchDistrictCore(
        province.province_id
      );
      this.districtList = [...this.districtList, ...districtByProvince];
      this.isLoadingDistrict = false;
    },
    async seach() {
      if (this.seaching == false) {
        if (this.$refs.form.validate()) {
          this.seaching = true;
          console.log(
            "district_id" in
              this.$store.state[this.action_method].config_path &&
              this.$store.state[this.action_method].config_path
                .district_id[0] != 0 &&
              this.$store.state[this.action_method].config_path
                .search_store_id == 0
          );
          if (
            "district_id" in
              this.$store.state[this.action_method].config_path &&
            this.$store.state[this.action_method].config_path.district_id[0] !=
              0 &&
            this.$store.state[this.action_method].config_path.search_store_id ==
              0
          ) {
            await this.$store.dispatch(
              this.action_method + "/fetchReportByDistrict"
            );
          } else {
            await this.$store.dispatch(
              this.action_method + "/getStoreListReport",
              this.$store.state[this.action_method].config_path
            );
          }
          this.seaching = false;
        }
      }
    },
    async getStoreList() {
      this.store_list = [];
      this.store_list.push({ store_id: 0, store_name_th: "All" });
      this.is_loading_store = true;
      let fetch_store_list = await this.$store.dispatch(
        "fetchStoreBack/getStoreList"
      );
      for (let val of fetch_store_list) {
        this.store_list.push(val);
      }
      this.is_loading_store = false;
    },
  },
  async created() {
    this.getStoreList();
    this.fetchDistrictList();
  },
};
</script>

<style scoped>
.v-text-field {
  padding-top: 0;
  margin-top: 0;
}
.search-btn {
  cursor: pointer;
  height: 50px;
  width: 50px;
  background-color: #ffd300;
  border-radius: 10px;
}

@media screen and (max-width: 662px) {
  .search__input {
    margin-bottom: 10px;
  }
}
</style>
